import { css } from '@emotion/react';
import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';

export const contestWrapperStyle = (hasParticipated: boolean) => css`
  margin-bottom: 8px;
  display: flex;
  padding: 12px 15px;
  ${hasParticipated
    ? `background: url(${`/webapp-assets/images/ILT/participatedContestBg.svg?v=${process.env.APP_VERSION}`})`
    : `background: ${!hasParticipated && colors.SubscriptionGrey};`}
`;

export const imageWrapperStyle = css`
  flex: 1;
  img {
    width: 99px;
    height: 56px;
    margin-bottom: 8px;
  }
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
`;

export const dateDetailsWrapperStyle = css`
  width: 134px;
  height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 47px;
  background: ${colors.black};
  color: ${colors.white};
  text-align: center;
  ${ZeeFontRegular(10)};
`;
export const contestDetailsWrapperStyle = css`
  flex: 1;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
`;

export const notParticipatedStyle = css`
  color: ${colors.white};
  margin-bottom: 8px;
  ${ZeeFontBold(14, 20)};
  font-weight: 900;
`;

export const answersWrapperStyle = css`
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const answersStyle = css`
  color: ${colors.white};
  ${ZeeFontBold(18)};
  font-weight: 900;
  line-height: normal;
`;

export const answersDetailsStyle = css`
  color: ${colors.white};
  ${ZeeFontBold(11)};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const participationDescriptionStyle = css`
  color: ${colors.white};
  ${ZeeFontRegular(11)};
  line-height: normal;
`;

export const winningPrizeImageStyle = css`
  width: 100%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 20px;
`;
